export class ComponentMessage {
  topic: MessageTopicsEnum;
  content: string | any;
}

export enum MessageTopicsEnum {
  Login,
  PaymentInfoResponse,
  PaymentInfoRequest,
  EditBundleRequest,
  CloseBundleBuilderRequest
}
